import definition from 'file_definition';
import assetdefinition from 'asset_definition';
global.app.sdk.file = global.app.create_sdk(definition, true);
if (global.app.name === 'file_ui') {
    global.app.sdk.asset = global.app.create_sdk(assetdefinition, true);
}
 